import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";

//STYLES
import { Action } from "./style"

//COMPONENTS
import { Switcher } from "../../../../../../Components/CustomUi/Switcher";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import ReactToPrint from 'react-to-print';
import { useAccess } from "../../../../../../context/useAccess";
import { Render } from "../../../../../../Components/CustomUi/render";

//PROPS
interface Props {
    exibir_terreno: boolean;
    setExibir_terreno: React.Dispatch<React.SetStateAction<boolean>>;
    exibir_lista_talhoes: boolean;
    setExibir_lista_talhoes: React.Dispatch<React.SetStateAction<boolean>>;
    nome_safra_selecionada: string;
    resumirBook: boolean;
}

export const HeaderBook: React.FC<Props> = ({ exibir_terreno, setExibir_terreno, nome_safra_selecionada, setExibir_lista_talhoes, exibir_lista_talhoes, resumirBook }) => {

    const { nameCliente } = useAccess()

    //REF
    const btnPrint = useRef<ReactToPrint>()

    //STATES
    const [fake_loading, setFake_loading] = useState(false);

    function fakeLoading() {
        setTimeout(() => {
            setFake_loading(false)
        }, 2000);
    }

    return (
        <Action>

            <Switcher 
                isChecked={exibir_lista_talhoes}
                trigger={setExibir_lista_talhoes}
                label='Exibir lista de talhões'
            />
            
            <Render condition={resumirBook === false}>
              <Switcher 
                isChecked={exibir_terreno}
                trigger={setExibir_terreno}
                label='Exibir terreno'
            />
            </Render>

            {/* <div className="Action__quality">
                <motion.button 
                    className="Action__quality__trigger"
                >
                    Qualidade melhorada
                </motion.button>
            </div> */}
            <ReactToPrint
                ref={btnPrint}
                trigger={() => (
                    <ButtonCustom
                        onClick={()=>{}}
                        icon={<FontAwesomeIcon icon={faPrint} />}
                        loading={fake_loading}
                    >
                        Imprimir
                    </ButtonCustom>
                )}
                // onBeforePrint={()=>{setFake_loading(true);fakeLoading()}}
                content={() => document.getElementById('book_fertilidade_resumido')}
                onBeforeGetContent={()=>{setFake_loading(true);fakeLoading()}}
                documentTitle={`Book_fertilidade_agrupado__${nome_safra_selecionada}__cliente_${nameCliente}`}
            />

            
        </Action>
    )
}